// extracted by mini-css-extract-plugin
export default {"spot":"Spotlight_spot__yxkww"};